import React from 'react';
import { observer, inject } from 'mobx-react';
import { Checkbox, Button, Panel } from 'react-bootstrap';
import { hashHistory } from 'react-router';
import Spinner from '../../common/spinner';
import Alert from '../../common/alert';
import PrivacyInformation from './policy';

@inject('stores') @observer
export default class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
        };
        this.handleOnClick = this.handleOnClick.bind(this);
        this.changeText = this.changeText.bind(this);
        this.changePref = this.changePref.bind(this);
        this.changeTown = this.changeTown.bind(this);
        this.agreePolicy = this.agreePolicy.bind(this);
        this.doScroll = this.doScroll.bind(this);
        this.setContact = this.setContact.bind(this);
        this.changeContactMethod = this.changeContactMethod.bind(this);
        this.props.stores.clearError();
    }

    componentWillMount() {
        if (this.props.stores.contactNecessity === '希望する') {
            this.setState({ open: true });
        }
    }

    setContact(e) {
        this.props.stores.contactNecessity = e.target.value;
        if (e.target.value === '希望する') {
            this.setState({ open: true });
        } else {
            this.setState({ open: false });
            this.props.stores.contactMethod = '';
        }
    }

    changeContactMethod(e) {
        this.props.stores.contactMethod = e.target.value;
    }

    agreePolicy(e) {
        this.props.stores.isAgreed = e.target.value;
    }

    handleOnClick() {
        if (this.isValidate()) {
            return hashHistory.replace('step2');
        }
        return null;
    }

    doScroll(e) {
        const el = e.target;
        const pageBottom = el.scrollHeight;
        const scrollBottom = el.scrollTop + el.offsetHeight;

        if (scrollBottom >= pageBottom) {
            this.props.stores.isScrolldBottom = true;
        }
    }

    isValidate() {
        const phonePartten = '^\\d{2,5}-\\d{1,4}-\\d{4}$';
        const mobilePartten = '^\\d{3}-\\d{4}-\\d{4}$';
        const kanaPattern = '^[　ーァ-ヶ]+$';
        const mailPartten = "^[a-zA-Z0-9!$&*.=^`|~#%'+/?_{}-]+@([a-zA-Z0-9_-]+.)+[a-zA-Z]{2,4}$";
        this.props.stores.clearError();
        if (this.props.stores.detail.length === 0) {
            this.props.stores.showErrorMessage('danger', '内容を入力してください');
            return false;
        }
        if ((this.props.stores.prefecture === '選択してください') ||
            (this.props.stores.town === '選択してください')) {
            this.props.stores.showErrorMessage('danger', '住所を選択してください');
            return false;
        }
        if ((this.props.stores.lastNameKanji.length === 0) ||
            (this.props.stores.firstNameKanji.length === 0)) {
            this.props.stores.showErrorMessage('danger', 'お名前（姓名）を入力してください');
            return false;
        }
        if ((this.props.stores.lastNameKana.length === 0) ||
            (this.props.stores.firstNameKana.length === 0)) {
            this.props.stores.showErrorMessage('danger', 'お名前（フリガナ）を入力してください');
            return false;
        }
        if ((!this.props.stores.firstNameKana.match(kanaPattern)) ||
            (!this.props.stores.lastNameKana.match(kanaPattern))) {
            this.props.stores.showErrorMessage('danger', 'お名前（フリガナ）は40文字以内の全角カタカナで入力してください。');
            return false;
        }
        if (this.props.stores.phone.length !== 0 && (!this.props.stores.phone.match(phonePartten)
            && !this.props.stores.phone.match(mobilePartten))) {
            this.props.stores.showErrorMessage('danger', '電話番号は14桁以内（半角数字ハイフン付き）で入力してください');
            return false;
        }
        if (this.props.stores.mail.length === 0) {
            this.props.stores.showErrorMessage('danger', 'メールアドレスを入力してください');
            return false;
        }
        if (!this.props.stores.mail.match(mailPartten)) {
            this.props.stores.showErrorMessage('danger', 'メールアドレスを正しく入力してください。');
            return false;
        }
        return true;
    }

    changeText(e) {
        this.props.stores.lastNameKanji = e.target.id === 'lastNameKanji' ? e.target.value : this.props.stores.lastNameKanji;
        this.props.stores.firstNameKanji = e.target.id === 'firstNameKanji' ? e.target.value : this.props.stores.firstNameKanji;
        this.props.stores.lastNameKana = e.target.id === 'lastNameKana' ? e.target.value : this.props.stores.lastNameKana;
        this.props.stores.firstNameKana = e.target.id === 'firstNameKana' ? e.target.value : this.props.stores.firstNameKana;
        this.props.stores.companyName = e.target.id === 'companyName' ? e.target.value : this.props.stores.companyName;
        this.props.stores.unitName = e.target.id === 'unitName' ? e.target.value : this.props.stores.unitName;
        this.props.stores.buildingNo = e.target.id === 'buildingNo' ? e.target.value : this.props.stores.buildingNo;
        this.props.stores.phone = e.target.id === 'phone' ? e.target.value : this.props.stores.phone;
        this.props.stores.mail = e.target.id === 'mail' ? e.target.value : this.props.stores.mail;
        this.props.stores.detail = e.target.id === 'detail' ? e.target.value : this.props.stores.detail;
    }

    changePref(e) {
        this.props.stores.showMunicipality = this.props.stores.municipality.filter(item => (
            item.pref === (e.target.value)
        ));
        this.props.stores.prefecture = e.target.value;
    }

    changeTown(e) {
        this.props.stores.town = e.target.value;
    }

    render() {
        const stores = this.props.stores;
        return (
            <div className="contentMain">
                <Spinner isLoading={this.props.stores.isLoading} />
                <div className="elem-status-step">
                    <ul className="step-1">
                        <li><span>0</span>1<span>.  内容入力</span></li>
                        <li><span>0</span>2<span>.  内容の確認</span></li>
                        <li><span>0</span>3<span>.  送信完了</span></li>
                    </ul>
                </div>
                <div className="form-horizontal">
                    <div className="form-inner">
                        <div className="fff">
                            <p>日頃より当社サービスをご利用いただき、誠にありがとうございます。<br /><br />
                            当社では、お客様にご満足いただける人材サービスの提供に努めておりますが、<br />
                            サービス全般についてのご意見、苦情などがございましたら、<br />
                            下記フォームよりご連絡ください。今後のサービス向上に活かしてまいります。</p>
                        </div>
                    </div>
                    <div className="form-inner">
                        <div className="fff">
                            <Spinner isLoading={this.props.stores.isLoading} />
                            <fieldset>
                                <Alert
                                    ErrMode={this.props.stores.errMode}
                                    Content={this.props.stores.errMessage}
                                    Show={this.props.stores.showError}
                                />
                                <div className="form-group">
                                    <label className="col-md-2 col-xs-6 control-label" htmlFor="label" >内容</label>
                                    <div className="col-md-2 col-xs-6"><span className="label label-danger requiredLabel">必須</span></div>
                                    <div className="col-md-8 col-xs-12">
                                        <textarea
                                            id="detail"
                                            type="text"
                                            maxLength="3000"
                                            rows="10"
                                            value={this.props.stores.detail}
                                            onChange={this.changeText}
                                        />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label className="col-md-2 col-xs-6 control-label" htmlFor="label" >貴社名</label>
                                    <div className="col-md-2 col-xs-6"><span className="label label-danger requiredLabel">必須</span></div>
                                    <div className="col-md-8 col-xs-12">
                                        <input
                                            id="companyName"
                                            className="form-control"
                                            type="text"
                                            maxLength="80"
                                            value={this.props.stores.companyName}
                                            onChange={this.changeText}
                                        />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label className="col-md-2 col-xs-6 control-label" htmlFor="label" >部署名</label>
                                    <div className="col-md-2 col-xs-6"><span className="label label-danger inessential">任意</span></div>
                                    <div className="col-md-8 col-xs-12">
                                        <input
                                            id="unitName"
                                            className="form-control"
                                            type="text"
                                            maxLength="80"
                                            value={this.props.stores.unitName}
                                            onChange={this.changeText}
                                        />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label className="col-md-2 col-xs-6 control-label" htmlFor="label" >お名前（姓名）</label>
                                    <div className="col-md-2 col-xs-6"><span className="label label-danger requiredLabel">必須</span></div>
                                    <div className="col-md-8 col-xs-12">
                                        <input
                                            id="lastNameKanji"
                                            className="form-control inputName"
                                            type="text"
                                            maxLength="20"
                                            value={this.props.stores.lastNameKanji}
                                            onChange={this.changeText}
                                            placeholder="姓"
                                        />
                                        <input
                                            id="firstNameKanji"
                                            className="form-control inputName"
                                            type="text"
                                            maxLength="20"
                                            value={this.props.stores.firstNameKanji}
                                            onChange={this.changeText}
                                            placeholder="名"
                                        />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label className="col-md-2 col-xs-6 control-label" htmlFor="label" >お名前（フリガナ）</label>
                                    <div className="col-md-2 col-xs-6"><span className="label label-danger requiredLabel">必須</span></div>
                                    <div className="col-md-8 col-xs-12">
                                        <input
                                            id="lastNameKana"
                                            className="form-control inputName"
                                            type="text"
                                            maxLength="20"
                                            value={this.props.stores.lastNameKana}
                                            onChange={this.changeText}
                                            placeholder="セイ"
                                        />
                                        <input
                                            id="firstNameKana"
                                            className="form-control inputName"
                                            type="text"
                                            maxLength="20"
                                            value={this.props.stores.firstNameKana}
                                            onChange={this.changeText}
                                            placeholder="メイ"
                                        />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label className="col-md-2 col-xs-6 control-label" htmlFor="label" >住所</label>
                                    <div className="col-md-2 col-xs-6"><span className="label label-danger requiredLabel">必須</span></div>
                                    <div className="col-md-8 col-xs-12">
                                        <select
                                            id="prefecture"
                                            className="form-control inputName"
                                            type="text"
                                            value={this.props.stores.prefecture}
                                            onChange={this.changePref}
                                        >
                                            <option value="">選択してください</option>
                                            {
                                                this.props.stores.municipality.map(
                                                    item =>
                                                        <option
                                                            key={item.pref}
                                                            value={item.pref}
                                                        >
                                                            {item.pref}
                                                        </option>,
                                                )
                                            }
                                        </select>
                                        <select
                                            id="showMunicipality"
                                            className="form-control inputName"
                                            type="text"
                                            value={this.props.stores.town}
                                            onChange={this.changeTown}
                                        >
                                            <option value="">選択してください</option>
                                            {
                                                this.props.stores.showMunicipality.map(
                                                    item =>
                                                        <option
                                                            key={item.i}
                                                            value={item.val}
                                                        >
                                                            {item.val}
                                                        </option>,
                                                )
                                            }
                                        </select>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label className="col-md-2 col-xs-6 control-label" htmlFor="label" >町名・番地</label>
                                    <div className="col-md-2 col-xs-6"><span className="label label-danger inessential">任意</span></div>
                                    <div className="col-md-8 col-xs-12">
                                        <input
                                            id="buildingNo"
                                            className="form-control"
                                            type="text"
                                            maxLength="255"
                                            value={this.props.stores.buildingNo}
                                            onChange={this.changeText}
                                        />
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label className="col-md-2 col-xs-6 control-label" htmlFor="label" >電話番号</label>
                                    <div className="col-md-2 col-xs-6"><span className="label label-danger inessential">任意</span></div>
                                    <div className="col-md-8 col-xs-12">
                                        <input
                                            id="phone"
                                            className="form-control"
                                            type="text"
                                            maxLength="14"
                                            value={this.props.stores.phone}
                                            onChange={this.changeText}
                                            placeholder="090-1234-5678"
                                        />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label className="col-md-2 col-xs-6 control-label" htmlFor="label" >メールアドレス</label>
                                    <div className="col-md-2 col-xs-6"><span className="label label-danger requiredLabel">必須</span></div>
                                    <div className="col-md-8 col-xs-12">
                                        <input
                                            id="mail"
                                            className="form-control"
                                            type="text"
                                            value={this.props.stores.mail}
                                            onChange={this.changeText}
                                            placeholder="example@pasona.com"
                                        />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label className="col-md-2 col-xs-6 control-label" htmlFor="label" >当社からの連絡</label>
                                    <div className="col-md-2 col-xs-6"><span className="label label-danger requiredLabel">必須</span></div>
                                    <div className="col-md-8 col-xs-12" onChange={this.setContact}>
                                        <input type="radio" value="希望する" name="contact" checked={this.props.stores.contactNecessity === '希望する'} /> 希望する
                                        {' '}
                                        <input type="radio" value="希望しない" name="contact" checked={this.props.stores.contactNecessity !== '希望する'} /> 希望しない
                                    </div>
                                </div>
                                <Panel collapsible expanded={this.state.open}>
                                    <div className="form-group" >
                                        <label className="col-md-2 col-xs-6 control-label" htmlFor="label" >ご希望の連絡方法</label>
                                        <div className="col-md-2 col-xs-6"><span className="label label-danger requiredLabel">必須</span></div>
                                        <div className="col-md-8 col-xs-12" onChange={this.changeContactMethod}>
                                            <input type="radio" value="電話" name="contactMethod" checked={this.props.stores.contactMethod === '電話'} /> 電話
                                            {' '}
                                            <input type="radio" value="メール" name="contactMethod" checked={this.props.stores.contactMethod === 'メール'} /> メール
                                            {' '}
                                            <input type="radio" value="どちらでもよい" name="contactMethod" checked={this.props.stores.contactMethod === 'どちらでもよい'} /> どちらでもよい
                                        </div>
                                    </div>
                                </Panel>
                                <Alert
                                    ErrMode={this.props.stores.errMode}
                                    Content={this.props.stores.errMessage}
                                    Show={this.props.stores.showError}
                                />
                            </fieldset>
                            <div className="elem-form-wrapper">
                                <div>
                                    <div className="form-inner">
                                        <p>下記個人情報の取り扱いについて、ご確認をお願い致します。</p>
                                        <div className="elem-policy" onScroll={this.doScroll}>
                                            <div className="elem-paragraph">
                                                <PrivacyInformation />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="elem-form-btn-wrapper">
                                        <div className="row-fluid">
                                            <div className="col-md-offset-3 col-md-6">
                                                <Checkbox className="agreeCheck" disabled={!this.props.stores.isScrolldBottom} onChange={this.agreePolicy}>
                                                    最後まで読んで同意します。
                                                </Checkbox>
                                            </div>
                                            <div className="col-md-offset-3 col-md-6">
                                                <div className="command">
                                                    <Button className="btn-danger" style={{ background: '#8a0808' }} disabled={!this.props.stores.isAgreed} block onClick={this.handleOnClick}>確認画面へ</Button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
App.propTypes = {
    stores: React.PropTypes.object,
};



// WEBPACK FOOTER //
// ./mypage/js/MPS_CompanyInquiry/components/index.jsx